<template>
  <div>
    <DashboardHeader title="Salaries & Payslips">
      <v-layout row wrap>
        <v-flex sm3 xs12>
          <v-card class="mx-1 mt-4">
            <v-toolbar color class="mb-1">
              <v-toolbar-title :style="{ color: getOutlineColor }" class="ml-1"
                >Payrolls</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-switch
                v-model="payrollSwitch"
                class="mt-6"
                label="All"
                @change="handlePayrollSwitch()"
              ></v-switch>
              <v-btn
                dark
                x-small
                class="ml-1"
                @click="openCreatePayrollDialog()"
                fab
                :color="getThemeColor"
                ><v-icon x-small>mdi-plus</v-icon></v-btn
              >
              <v-btn
                dark
                fab
                x-small
                @click="openGlobalConfirmDeleteDialog('delete')"
                color="red"
                class="ml-1"
                ><v-icon x-small>mdi-delete</v-icon></v-btn
              >
            </v-toolbar>

            <v-virtual-scroll :items="payrolls" height="600" item-height="150">
              <template v-slot:default="props">
                <v-list two-line>
                  <v-list-item :key="props.index + Math.random()">
                    <v-list-item-content>
                      <v-list-item-subtitle
                        :style="{ color: '#1A237E' }"
                        v-text="
                          'Payroll Month: ' +
                          props.item.month +
                          ' [' +
                          props.item.year +
                          ']'
                        "
                      ></v-list-item-subtitle>

                      <v-list-item-subtitle
                        :style="{ color: '#1B5E20' }"
                        v-text="'Total Earnings: ' + props.item.total_earnings"
                      ></v-list-item-subtitle>

                      <v-list-item-subtitle
                        :style="{ color: 'blue' }"
                        v-text="'Total Paye: ' + props.item.total_paye"
                      ></v-list-item-subtitle>

                      <v-list-item-subtitle
                        :style="{ color: 'red' }"
                        v-text="
                          'Total Deductions: ' + props.item.total_deductions
                        "
                      ></v-list-item-subtitle>

                      <v-list-item-subtitle
                        :style="{ color: '#880E4F' }"
                        v-text="
                          'Total Salary Paid: ' +
                          getCurrency +
                          props.item.total_salary_paid
                        "
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-checkbox
                        class="shrink"
                        :value="props.item.id"
                        v-model="selectedPayrolls"
                      ></v-checkbox>
                      <v-icon
                        :color="getThemeColor"
                        @click="manageSelectedPayroll(props.item)"
                        >mdi-chevron-triple-right</v-icon
                      >
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-flex>
        <v-flex sm3 xs12>
          <v-card class="mx-1 mt-4">
            <v-toolbar color class="mb-1">
              <v-toolbar-title
                :style="{ color: getOutlineColor }"
              ></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-switch
                v-model="employeesSwitch"
                class="mt-6 mr-2"
                label="All"
                @change="handleEmployeesSwitch()"
              ></v-switch>

              <v-btn
                :color="getThemeColor"
                rounded
                dark
                x-small
                @click="addSelectedEmployeesToPayroll()"
                >Add to Payroll
                <v-icon right>mdi-chevron-triple-right</v-icon>
              </v-btn>
            </v-toolbar>

            <v-virtual-scroll :items="[1]" height="600" item-height="600">
              <template v-slot:default="props">
                <v-list two-line>
                  <v-list-item :key="props.index + Math.random()">
                    <v-list-item-content>
                      <v-container fluid v-if="showEmployeesToBeSelected">
                        <v-data-table
                          :headers="employeesSelectionHeaders"
                          :items="employees"
                          :items-per-page="7"
                          class="elevation-1 mt-4"
                        >
                          <template v-slot:item.selection="{ item }">
                            <v-checkbox
                              class="shrink"
                              :value="item.id_number"
                              v-model="selectedEmployees"
                            ></v-checkbox>
                          </template>
                        </v-data-table>
                      </v-container>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-flex>
        <v-flex sm6 xs12>
          <v-card class="ml-1 mt-4">
            <v-toolbar color class="mb-1">
              <v-toolbar-title :style="{ color: getOutlineColor }"
                ><v-btn
                  class="mr-1 mt-0"
                  x-large
                  text
                  :color="getSecondaryColor"
                  >Payroll</v-btn
                ></v-toolbar-title
              >
              <v-spacer></v-spacer>
              <div v-if="showEmployeesToBeSelected">
                <v-btn
                  class="mr-1"
                  x-small
                  rounded
                  color="light-blue"
                  dark
                  @click="generatePayslipsPDF()"
                  ><v-icon left>mdi-printer</v-icon>Print</v-btn
                >

                <v-icon
                  class="mr-1"
                  color="red"
                  @click="openGlobalConfirmDeleteDialog('remove')"
                  >mdi-delete</v-icon
                >
              </div>
            </v-toolbar>

            <v-virtual-scroll :items="[1]" height="600" item-height="600">
              <template v-slot:default="props">
                <v-list two-line>
                  <v-list-item :key="props.index + Math.random()">
                    <v-list-item-content>
                      <v-container v-if="showEmployeesToBeSelected">
                        <v-data-table
                          :headers="payslipsHeaders"
                          :items="employeesOnPayroll"
                          :items-per-page="7"
                          class="elevation-1 mt-4"
                        >
                          <template v-slot:item.selection="{ item }">
                            <v-checkbox
                              class="shrink"
                              :value="item.id_number"
                              v-model="selectedPayslips"
                            ></v-checkbox>
                          </template>
                        </v-data-table>
                      </v-container>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog v-model="dialog" min-width="500">
        <v-card v-if="createPayroll">
          <v-card-title
            :style="{
              'backdround-color': getThemeColor,
              color: getSecondaryColor,
            }"
            class="text-h5 lighten-2"
            >Create Payroll</v-card-title
          >

          <v-card shaped elevation="12" outlined class="mx-10">
            <CreatePayroll
              @payroll-created="payrollCreated"
              v-if="isManager"
            ></CreatePayroll>
          </v-card>
          <v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-col cols="2">
                <v-btn color="red" dark @click="closeDialog()">Cancel</v-btn>
              </v-col>
            </v-card-actions>
          </v-container>
        </v-card>
        <v-card v-else-if="earningAndDeduction">
          <v-card-title
            :style="{
              'backdround-color': getThemeColor,
              color: getSecondaryColor,
            }"
            class="text-h5 lighten-2"
            >Create Payroll</v-card-title
          >

          <v-card shaped elevation="12" outlined class="mx-10">
            <EariningsAndDeductions
              :employeesIDs="selectedPayslips"
              :payrollID="selectedPayrollID"
              @earnings-and-deductions-created="earningsAndDeductionsCreated"
              v-if="isManager"
            ></EariningsAndDeductions>
          </v-card>
          <v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-col cols="2">
                <v-btn color="red" dark @click="closeDialog()">Cancel</v-btn>
              </v-col>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <GlobalConfirmDeleteDialog
        @delete-confirmed="takeActionAfterPayrollDeleteChoice"
        :item="deleteItem"
      ></GlobalConfirmDeleteDialog>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import CreatePayroll from "@/components/StaffAndHR/CreatePayroll.vue";
import EariningsAndDeductions from "@/components/StaffAndHR/EariningsAndDeductions.vue";
import GlobalConfirmDeleteDialog from "@/components/myLibrary/GlobalConfirmDeleteDialog.vue";
import DashboardHeader from "@/components/DashboardHeader.vue";

export default {
  components: {
    DashboardHeader,
    CreatePayroll,
    GlobalConfirmDeleteDialog,
    EariningsAndDeductions,
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
  },
  mounted() {
    this.getAllPayrolls();
  },
  data: () => ({
    dialog: false,
    whichConfirmDelete: null,
    deleteItem: null,
    createPayroll: false,
    employees: [],
    employeesOnPayroll: [],
    payslipTotalsData: null,
    payslips: [],
    showEmployeesToBeSelected: false,
    employeesSwitch: true,
    selectedEmployees: [],
    selectedPayslips: [],
    payrollSwitch: null,
    payrolls: [],
    selectAll: false,
    selectedPayrolls: [],
    selectedPayroll: null,
    selectedPayrollID: null,
    earningAndDeduction: false,
    search: null,
    headers: [
      { value: "selection" },
      { text: "Manage Payroll", value: "profile" },
      { text: "Month", value: "month" },
      { text: "Year", value: "year" },
      { text: "Pay Date", value: "pay_date" },
      {
        text: "Total Earnings",
        align: "start",
        value: "total_earnings",
      },
      { text: "Total Paye", value: "total_paye" },
      { text: "Total Deductions", value: "total_deductions" },
      { text: "Total Salaries To Be Paid", value: "total_salary_paid" },
    ],
    employeesSelectionHeaders: [
      { value: "selection" },
      {
        text: "Employee",
        align: "start",
        value: "name",
      },
    ],
    payslipsHeaders: [
      { value: "selection" },
      {
        text: "Employee",
        align: "start",
        value: "name",
      },
      {
        text: "Gross Earnings",
        value: "gross_earnings",
      },
      {
        text: "Paye",
        value: "paye",
      },
      {
        text: "Gross Deductions",
        value: "gross_deductions",
      },
      {
        text: "Net Salary",
        value: "net_salary",
      },
    ],
  }),
  methods: {
    getAllPayrolls() {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-all-payrolls-for-current-year", this.getAccessToken)
        .then((payrolls) => {
          this.payrolls = payrolls;
          this.$store.commit("setLoader", false);
        });
    },
    updateField(id, column) {
      const value = event.target.value;
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table: "employees", id, column, value },
          this.getAccessToken
        )
        .then((response) => {
          const nothing = response;
        });
    },
    selectAllpayrolls() {
      if (this.selectAll) {
        this.selectedpayrolls = [];
        this.payrolls.forEach((staf) => {
          this.selectedpayrolls.push(staf.id);
        });
      } else {
        this.selectedpayrolls = [];
      }
    },
    manageSelectedPayroll(payroll) {
      this.$store.commit("setLoader", true);
      this.selectedPayroll = payroll;
      this.selectedPayrollID = payroll.id;
      axios
        .postDataWithToken(
          "/auth/get-payroll-data",
          payroll,
          this.getAccessToken
        )
        .then((payrollData) => {
          this.employees = payrollData.employees;
          payrollData.employees.forEach((employee) => {
            this.selectedEmployees.push(employee.id_number);
          });
          axios
            .postDataWithToken(
              "/auth/get-employees-already-on-payslip",
              { payrollID: this.selectedPayrollID },
              this.getAccessToken
            )
            .then((payslipsData) => {
              this.employeesOnPayroll = payslipsData.employees;
              this.payslipTotalsData = payslipsData.payroll;
              this.showEmployeesToBeSelected = true;
              this.employeesSwitch = true;
              this.$store.commit("setLoader", false);
            });
        });
    },
    payrollCreated(payrolls) {
      this.payrolls = payrolls;
      this.closeDialog();
    },
    openCreatePayrollDialog() {
      this.dialog = true;
      this.createPayroll = true;
    },
    closeDialog() {
      this.dialog = false;
      this.createPayroll = false;
      this.earningAndDeduction = false;
    },

    handlePayrollSwitch() {
      if (this.payrollSwitch) {
        this.selectedPayrolls = [];
        this.payrolls.forEach((payroll) => {
          this.selectedPayrolls.push(payroll.id);
        });
      } else {
        this.selectedPayrolls = [];
      }
    },
    handleEmployeesSwitch() {
      if (this.employeesSwitch) {
        this.selectedEmployees = [];
        this.employees.forEach((employee) => {
          this.selectedEmployees.push(employee.id_number);
        });
      } else {
        this.selectedEmployees = [];
      }
    },
    openGlobalConfirmDeleteDialog(btn) {
      if (btn == "delete" && this.selectedPayrolls.length < 1) {
        alert("Select Aleast 1 Payroll");
        event.preventDefault();
      } else if (btn == "remove" && this.selectedPayslips.length < 1) {
        alert("Select Aleast 1 Staff");
        event.preventDefault();
      } else {
        this.whichConfirmDelete = btn;
        if (btn == "delete") {
          this.deleteItem = "Payroll";
        } else if (btn == "remove") {
          this.deleteItem = "Staff From Payroll";
        }
        this.$store.commit("setGlobalConfirmDelete", true);
      }
    },
    takeActionAfterPayrollDeleteChoice(choice) {
      if (choice) {
        if (this.whichConfirmDelete == "delete") {
          this.$store.commit("setLoader", true);
          axios
            .postDataWithToken(
              "/auth/delete-selected-payrolls",
              { selectedPayrollIDs: this.selectedPayrolls },
              this.getAccessToken
            )
            .then((payrolls) => {
              this.payrolls = payrolls;
              this.$store.commit("setLoader", false);
            });
        } else if (this.whichConfirmDelete == "remove") {
          this.$store.commit("setLoader", true);
          axios
            .postDataWithToken(
              "/auth/remove-staff-from-payroll",
              {
                selectedPayslips: this.selectedPayslips,
                selectedPayrollID: this.selectedPayrollID,
              },
              this.getAccessToken
            )
            .then(() => {
              this.$store.commit("setLoader", false);

              this.manageSelectedPayroll(this.selectedPayroll);
            });
        }
      } else {
        this.$store.commit("setGlobalConfirmDelete", false);
      }
    },
    earningsAndDeductionsCreated() {
      this.closeDialog();
      this.manageSelectedPayroll(this.selectedPayroll);
    },
    addSelectedEmployeesToPayroll() {
      if (this.selectedEmployees.length < 1) {
        alert("Select Aleast 1 Employee");
        event.preventDefault();
      } else {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/add-selected-employees-to-payroll",
            {
              selectedEmployees: this.selectedEmployees,
              payrollID: this.selectedPayrollID,
            },
            this.getAccessToken
          )
          .then((payslipsData) => {
            this.employeesOnPayroll = payslipsData.employees;
            this.payslipTotalsData = payslipsData.payroll;
            this.manageSelectedPayroll(this.selectedPayroll);
            this.$store.commit("setLoader", false);
          });
      }
    },
    generatePayslipsPDF() {
      this.$router.push({
        name: "get-payslips-pdf",
        params: { employeesOnPayroll: this.employeesOnPayroll },
      });
    },
  },
};
</script>

<style></style>
